import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/resources/online-payments.svg'


const _withScopeId = n => (_pushScopeId("data-v-adc33bb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-1" }, "Success!", -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Your payment account was successfully created, and you can now begin using Opt to request meetings", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "payment-image",
  src: _imports_0
}, null, -1 /* HOISTED */))
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Back to Home")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", _hoisted_4, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createElementVNode("button", {
      class: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goTo('links')))
    }, "Meeting Types")
  ], 64 /* STABLE_FRAGMENT */))
}